// Resolve Shopify asset URLs - SS_ASSETS is populated by the section liquid files
function ssAsset(name) {
  if (window.SS_ASSETS && window.SS_ASSETS[name]) return window.SS_ASSETS[name];
  return name; // fallback to filename only
}

const IMGS = {
  // Hopper product images — child/playroom focused
  "h_main":    'scene-girl-jumping.jpg',
  "h_room":    'scene-room-corner.jpg',
  "h_float":   'lifestyle-leaf-child-v6.jpg',
  "h_studio":  'editorial-child-reading-v4.jpg',
  "h_lift":    'lifestyle-blue-leaf-lift-v5.jpg',
  "h_living":  'scene-coffee-table.jpg',
  "h_kid1":    'scene-toddler-bouncing.jpg',
  "h_kid2":    'lifestyle-leaf-child-v6.jpg',
  "h_kid3":    'bounder-child-bounce-enhanced.jpg',
  "h_topper":  'scene-dog-napping.jpg',
  "h_mom_baby":'bounder-family-moment-enhanced.jpg',
  "h_playroom":'editorial-child-reading-v4.jpg',
  // Bounder product images — family/lifestyle focused
  "b_main":    'detail-gingham.jpg',
  "b_mirror1": 'lifestyle-gingham-lift-v5.jpg',
  "b_mirror2": 'lifestyle-gingham-lift-v3.jpg',
  "b_mirror3": 'scene-room-corner.jpg',
  "b_drama":   'scene-room-corner.jpg',
  "b_gingham1":'lifestyle-gingham-lift-v5.jpg',
  "b_gingham2":'lifestyle-gingham-lift-v3.jpg',
};
IMGS["h_living_open"] = 'scene-coffee-table.jpg';
IMGS["h_white_open"] = 'lifestyle-arch-ottoman.jpg';
IMGS["h_lift_close"] = 'lifestyle-blue-leaf-lift-v5.jpg';
IMGS["h_room_open"] = 'scene-room-corner.jpg';
IMGS["h_lift_wide"] = 'lifestyle-gingham-lift-v5.jpg';
IMGS["h_sit_leaf"] = 'scene-dog-napping.jpg';
IMGS["h_feet_leaf"] = 'scene-coffee-table.jpg';
IMGS["h_playroom1"] = 'editorial-child-reading-v4.jpg';
IMGS["h_playroom2"] = 'lifestyle-leaf-child-v6.jpg';
IMGS["h_studio_open1"] = 'scene-coffee-table.jpg';
IMGS["h_studio_open2"] = 'editorial-child-reading-v4.jpg';
IMGS["h_mom_room"] = 'bounder-family-moment-enhanced.jpg';
IMGS["h_mom_toddler1"] = 'scene-toddler-bouncing.jpg';
IMGS["h_mom_room2"] = 'bounder-family-moment-enhanced.jpg';
IMGS["h_mom_toddler2"] = 'scene-toddler-bouncing.jpg';
IMGS["h_kid_jump_room"] = 'bounder-child-bounce-enhanced.jpg';
IMGS["h_woman_seated"] = 'lifestyle-arch-ottoman.jpg';
IMGS["h_mom_toddler3"] = 'scene-toddler-bouncing.jpg';
IMGS["h_kid_jump2"] = 'lifestyle-leaf-child-v6.jpg';
IMGS["h_read_feet"] = 'editorial-child-reading-v4.jpg';
IMGS["h_read_lid"] = 'scene-dog-napping.jpg';
IMGS["h_read_wide"] = 'scene-room-corner.jpg';
IMGS["h_mom_baby"] = 'bounder-family-moment-enhanced.jpg';
IMGS["h_puppy"] = 'lifestyle-floral-dog.jpg';
IMGS["b_leaf_room"] = 'scene-room-corner.jpg';
IMGS["b_leaf_lift1"] = 'lifestyle-gingham-lift-v5.jpg';
IMGS["b_leaf_lift2"] = 'lifestyle-gingham-lift-v3.jpg';
IMGS["b_leaf_lift3"] = 'detail-gingham.jpg';
IMGS["b_cream_room"] = 'lifestyle-arch-ottoman.jpg';
IMGS["b_cream_kid1"] = 'bounder-child-bounce-enhanced.jpg';
IMGS["b_cream_kid2"] = 'scene-toddler-bouncing.jpg';
IMGS["b_cream_wide"] = 'bounder-family-moment-enhanced.jpg';
IMGS["b_cream_kid3"] = 'lifestyle-leaf-child-v6.jpg';
IMGS["b_cream_woman"] = 'lifestyle-blue-leaf-lift-v5.jpg';
IMGS["b_cream_man"] = 'scene-room-corner.jpg';
IMGS["b_cream_kid4"] = 'editorial-child-reading-v4.jpg';
IMGS["b_family_dad"] = 'bounder-family-moment-enhanced.jpg';
IMGS["b_family1"] = 'bounder-family-moment-enhanced.jpg';
IMGS["b_family2"] = 'bounder-child-bounce-enhanced.jpg';
IMGS["b_family_girl"] = 'lifestyle-leaf-child-v6.jpg';
IMGS["b_family_kids"] = 'scene-toddler-bouncing.jpg';
IMGS["b_family_crawl"] = 'bounder-child-bounce-enhanced.jpg';
IMGS["b_family3"] = 'bounder-family-moment-enhanced.jpg';
IMGS["b_floral_lift"] = 'lifestyle-floral-dog.jpg';
IMGS["b_floral_feet"] = 'detail-floral.jpg';
IMGS["b_floral_open"] = 'lifestyle-floral-dog.jpg';
IMGS["b_floral_puppy1"] = 'lifestyle-floral-dog.jpg';
IMGS["b_floral_puppy2"] = 'scene-dog-napping.jpg';
IMGS["b_tan_lift"] = 'lifestyle-blue-leaf-lift-v5.jpg';
IMGS["b_tan_lift2"] = 'lifestyle-gingham-lift-v3.jpg';
IMGS["b_tan_feet1"] = 'detail-tan-leaf.jpg';
IMGS["b_tan_feet2"] = 'scene-coffee-table.jpg';
IMGS["b_tan_lift3"] = 'lifestyle-arch-ottoman.jpg';
IMGS["b_tan_sit"] = 'scene-dog-napping.jpg';
IMGS["b_tan_feet3"] = 'detail-tan-leaf.jpg';
IMGS["b_tan_lift4"] = 'lifestyle-blue-leaf-lift-v5.jpg';
IMGS["b_tan_feet4"] = 'scene-coffee-table.jpg';
IMGS["b_tan_lift5"] = 'lifestyle-gingham-lift-v5.jpg';
IMGS["b_tan_feet5"] = 'detail-tan-leaf.jpg';
IMGS["b_tan_lift6"] = 'lifestyle-arch-ottoman.jpg';
IMGS["b_tan_lift7"] = 'lifestyle-blue-leaf-lift-v5.jpg';
IMGS["b_tan_toddler1"] = 'scene-toddler-bouncing.jpg';
IMGS["b_tan_toddler2"] = 'bounder-child-bounce-enhanced.jpg';
IMGS["b_tan_kid1"] = 'lifestyle-leaf-child-v6.jpg';
IMGS["b_tan_kid2"] = 'bounder-child-bounce-enhanced.jpg';
IMGS["b_tan_kid3"] = 'scene-toddler-bouncing.jpg';
IMGS["b_tan_kid4"] = 'editorial-child-reading-v4.jpg';
IMGS["b_tan_toddler3"] = 'scene-toddler-bouncing.jpg';
IMGS["b_tan_kid5"] = 'lifestyle-leaf-child-v6.jpg';
IMGS["b_tan_kid6"] = 'bounder-child-bounce-enhanced.jpg';
IMGS["b_tan_kid7"] = 'editorial-child-reading-v4.jpg';
IMGS["b_tan_kid8"] = 'scene-toddler-bouncing.jpg';
IMGS["b_tan_bounce"] = 'bounder-child-bounce-enhanced.jpg';
IMGS["b_blue_sit"] = 'lifestyle-arch-ottoman.jpg';
IMGS["b_blue_lift1"] = 'lifestyle-blue-leaf-lift-v5.jpg';
IMGS["b_blue_sit2"] = 'scene-coffee-table.jpg';
IMGS["b_blue_lift2"] = 'lifestyle-gingham-lift-v5.jpg';
IMGS["b_blue_room"] = 'scene-room-corner.jpg';
IMGS["b_blue_kid"] = 'bounder-child-bounce-enhanced.jpg';
IMGS["b_blue_toddler"] = 'scene-toddler-bouncing.jpg';
IMGS["b_gingham_lift"] = 'lifestyle-gingham-lift-v5.jpg';
IMGS["b_gingham_mirror"] = 'lifestyle-gingham-lift-v3.jpg';

/* ═══════════════════════════════════════
   SPRING & STITCH PROTOTYPE JAVASCRIPT
═══════════════════════════════════════ */

// ── STATE ──
const cart = [];
const faqs = [
  // PRODUCT INFO
  { cat: 'product', q: 'What is The Bounder™?', a: 'The Bounder™ is the Trampoline Ottoman™ furniture for adults and families — a real commercial-grade indoor rebounder hidden inside a beautifully upholstered, skirted ottoman. It features designer fabrics (block-printed linens, classic ginghams, modern botanicals), a 40-inch family-size frame, and holds 440 lbs. Designed to live beside your sofa, not in your garage. Starting at from $799.' },
  { cat: 'product', q: "What’s the difference between The Bounder™ and The Hopper™?", a: '<strong>The Hopper™</strong> ($399) is the kids’ version — 36-inch kid-size frame, sensory microsuede, playful colors built for the playroom. Ages 2–10 recommended.<br><br><strong>The Bounder™</strong> (from $799+) is the grown-up version — 40-inch family-size frame, designer upholstery (gingham, linen, botanical prints), made for your living room. Both hold 440 lbs and are virtually silent.' },
  { cat: 'product', q: 'What sizes do you offer?', a: 'The Bounder™ is available in a <strong>36&Prime; frame</strong> (compact, great for smaller spaces and playrooms) or a <strong>40&Prime; frame</strong> (full family-size, ideal for living rooms). Both are round, low-profile, and designed to fit naturally in any room.' },
  { cat: 'product', q: 'What fabrics are available?', a: '<strong>The Bounder™</strong> features designer fabrics including block-printed linens, classic ginghams, modern botanicals, textured weaves, and minimalist solids — all selected for durability and style. Performance Solids are bleach-cleanable and PFAS-free. Designer Patterns are dry-clean only.' },
  { cat: 'product', q: 'What comes in the box?', a: 'Every piece ships complete: the <strong>Trampoline Frame</strong> with commercial-grade springs, the <strong>Spring Skirt</strong> that wraps the frame, the <strong>Snap-On Wrap</strong> that clicks onto the spring cover to finish the skirt in seconds, and the <strong>Ottoman Topper</strong> with foam inserts already inside. Minimal assembly required.' },
  { cat: 'product', q: 'How is this different from a mini trampoline?', a: 'Mini trampolines are exercise equipment — metal frames, handlebars, gym-floor aesthetic. Ours is furniture. Beautifully upholstered, no bars, no exposed springs, designed to sit in your living room or playroom. Same commercial-grade bounce, completely different category.' },
  { cat: 'product', q: 'Can adults really use it?', a: '440 lbs. Absolutely. Adults use The Bounder™ for movement breaks while working from home, stress relief, light rebounding exercise, and honestly just fun. Both products also work perfectly as regular ottomans for sitting.' },
  { cat: 'product', q: 'Is it actually safe?', a: 'Yes. 440 lb weight capacity with a low-profile design that keeps the bounce surface just inches off the ground. No exposed springs, no bars, no tipping risk. Always supervise children under 4.' },
  { cat: 'product', q: 'Is it loud?', a: 'Virtually silent. The springs are fully enclosed inside the upholstered frame — no metal-on-metal sound. Apartment-friendly and neighbor-approved.' },
  { cat: 'product', q: 'Is it patent pending?', a: 'Yes. The Trampoline Ottoman™ furniture design is patent pending. Spring & Stitch is the original creator of this product category.' },
  { cat: 'product', q: 'Will the springs wear out?', a: 'Commercial-grade springs rated for hundreds of thousands of bounces. We offer a warranty and replacement springs are available if ever needed.' },
  { cat: 'product', q: 'Can I swap covers or change the look?', a: 'Yes! The covers are removable and we sell additional cover sets so you can swap colors with the seasons or your mood. Same frame, endless looks.' },

  // ORDERING
  { cat: 'ordering', q: 'How do I place an order?', a: 'Visit our Shop page, choose your frame size and fabric, and add to cart. Each order is custom-made to your specifications, so make sure you’re happy with your selections before checking out.' },
  { cat: 'ordering', q: 'What payment methods do you accept?', a: 'We accept Visa, Mastercard, American Express, Discover, PayPal, Apple Pay, Google Pay, and Shop Pay. We also offer Shop Pay installments for interest-free split payments.' },
  { cat: 'ordering', q: 'Do you offer financing or payment plans?', a: 'Yes! We offer Shop Pay installments at checkout, which allows you to split your purchase into interest-free payments. Select Shop Pay as your payment method during checkout to see available options.' },
  { cat: 'ordering', q: 'Can I cancel or change my order?', a: 'Because each order is handmade to your specifications, please reach out as soon as possible if you need to make changes. Contact hello@springandstitch.shop within 24 hours of placing your order. Once production has started, we may not be able to modify your order.' },
  { cat: 'ordering', q: 'Where can I buy Spring & Stitch products?', a: 'The only place to purchase authentic Spring & Stitch products is springandstitch.shop. We do not sell through Amazon, Walmart, or any third-party retailers.' },
  { cat: 'ordering', q: 'Do you offer gift cards?', a: 'Not yet — but it’s on our list! In the meantime, if you’d like to gift a Bounder™ or Hopper™, contact us and we can help coordinate a surprise delivery.' },

  // SHIPPING
  { cat: 'shipping', q: 'How long does shipping take?', a: 'Every Bounder™ is handmade to order. Standard production time is 2–3 weeks, after which your order ships. Once shipped, delivery typically takes 3–7 business days. Need it sooner? We offer expedited processing that ships within 2–3 weeks for an additional fee.' },
  { cat: 'shipping', q: 'Is shipping free?', a: 'Yes! Free shipping on all orders within the contiguous United States. Orders to Alaska, Hawaii, and U.S. territories may incur additional charges.' },
  { cat: 'shipping', q: 'Where do you ship from?', a: 'All Spring & Stitch products are handcrafted and shipped from our studio in Blue Ridge, Georgia.' },
  { cat: 'shipping', q: 'Do you ship internationally?', a: 'We currently ship within the United States only. International shipping is something we’re working toward — sign up for our newsletter to be the first to know when it’s available.' },
  { cat: 'shipping', q: 'Will I receive tracking information?', a: 'Yes! You’ll receive a shipping confirmation email with a tracking number as soon as your order leaves our studio.' },
  { cat: 'shipping', q: 'Can I change my shipping address after ordering?', a: 'We’re happy to help with address changes as long as your order hasn’t shipped. Contact hello@springandstitch.shop as soon as possible.' },
  { cat: 'shipping', q: 'Can you ship to a PO Box?', a: 'Due to the size of our packages, we’re unable to ship to PO Boxes. Please provide a street address for delivery.' },
  { cat: 'shipping', q: 'Does it ship in a box?', a: 'Yes — no white-glove delivery required. The Trampoline Ottoman™ furniture ships in a standard box and can be brought inside and assembled by one person in about 3 minutes with minimal tools.' },

  // RETURNS & WARRANTY
  { cat: 'returns', q: "What is your return policy?", a: '30-day guarantee: love it or bounce. If you’re not completely in love within 30 days of delivery, contact us to initiate a return. A $89 return shipping fee will be deducted from your refund. Because every order is custom-made to your specifications, we cannot accept returns for change of mind outside the 30-day window. Products that have been damaged by the consumer — including tears, stains, structural damage, or misuse — are not eligible for return or refund.' },
  { cat: 'returns', q: 'What if my order arrives damaged?', a: 'We take great care in packaging every order, but if something arrives damaged, please email hello@springandstitch.shop within 7 days of delivery with 2–3 photos of the damage. We’ll arrange a replacement or repair as quickly as possible.' },
  { cat: 'returns', q: 'Do you offer a warranty?', a: 'Yes. Every Bounder™ comes with a limited warranty covering manufacturing defects in materials and workmanship — including seams, zippers, fabric integrity, and structural components under normal use. The warranty does not cover damage caused by the consumer, including tears, burns, stains, structural damage from misuse, pet damage, or normal wear and tear. Consumer-damaged products are also not eligible for return.' },
  { cat: 'returns', q: 'Can I exchange my fabric choice?', a: 'Since each product is made to order with your selected fabric, exchanges aren’t possible once production has started. If you’re unsure about a fabric, contact us before ordering — we’re happy to help you choose.' },

  // CARE
  { cat: 'care', q: 'How do I clean The Bounder™?', a: 'The Ottoman Topper cover is removable and can be spot cleaned with a damp cloth and mild soap. For the Spring Skirt, spot clean only. The Performance Solid fabric option is bleach-cleanable — mix 1 cup bleach + 1 tsp dish soap per quart of water, apply, leave up to 10 min, rinse thoroughly, and air dry. Do not machine wash linen covers.' },
  { cat: 'care', q: 'Is the fabric pet-friendly?', a: 'Yes — our Revolution Performance Fabric options are scratch and fur resistant, making them ideal for pet-friendly households. The fabric is also bleach-cleanable, so accidents are never a disaster.' },
  { cat: 'care', q: 'How long will it last?', a: 'Our covers are built to last. Every seam is reinforced for thousands of jumps, and our fabrics are selected for long-term durability. With proper care, your Bounder™ should last for years of daily use.' },
  { cat: 'care', q: 'Can I order replacement covers?', a: 'Yes! If you want to refresh your look or need a replacement, contact hello@springandstitch.shop and we’ll set you up with a new Trampoline Ottoman™ covers set in any available fabric.' }
];

// ── PAGE NAVIGATION ──
function showPage(name) {
  document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
  const page = document.getElementById('page-' + name);
  if (page) {
    page.classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  // Update active nav
  document.querySelectorAll('.header-nav a').forEach(a => a.classList.remove('active'));
  const map = { home:'', shop:'shop', bounder:'bounder', story:'story', faq:'faq', cart:'cart', contact:'contact', press:'press', covers:'covers', shipping:'shipping', care:'care', warranty:'warranty', 'bounder-cover':'bounder' };
  document.querySelectorAll('.header-nav a').forEach(a => {
    if (a.getAttribute('onclick') && a.getAttribute('onclick').includes("'" + name + "'")) {
      a.classList.add('active');
    }
  });
  // Render dynamic pages
  if (name === 'faq') renderFaq();
  if (name === 'cart') renderCart();
  // Trigger reveal animations
  setTimeout(() => initReveal(), 100);
}

// ── MOBILE NAV ──
function toggleMobileNav() {
  const nav = document.getElementById('mobile-nav');
  nav.classList.toggle('open');
  document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
}

// ── SCROLL EFFECT ──
window.addEventListener('scroll', () => {
  document.getElementById('site-header').classList.toggle('scrolled', window.scrollY > 20);
}, { passive: true });

// ── PRODUCT GALLERY THUMBS ──
function selectThumb(el, emoji, imgId) {
  const mainImgId = imgId || 'bounder-main-img';
  const thumbsContainer = el.closest('.pdp-thumbs');
  if (thumbsContainer) thumbsContainer.querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
  const mainImg = document.getElementById(mainImgId);
  if (mainImg) mainImg.textContent = emoji;
}

// ── SWATCH SELECTION ──
function selectSwatch(el, product, colorName) {
  const container = document.getElementById(product + '-swatches');
  if (container) container.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
  el.classList.add('active');
  const nameEl = document.getElementById(product + '-color-name');
  if (nameEl) nameEl.textContent = colorName;
  // Update add to cart button text
  const cartBtn = el.closest('.pdp-info')?.querySelector('.add-to-cart-btn');
  if (cartBtn) {
    const productName = 'The Bounder™';
    const price = 'from $799';
    const emoji = '🦘';
    cartBtn.setAttribute('onclick', `addToCart('${productName}','${colorName}','${price}','${emoji}')`);
  }
}

// ── SHOPIFY AJAX CART ──
// Adds a variant to the real Shopify cart via AJAX, then optionally redirects.
function ssAddToCart(variantId, btnEl, redirectAfter) {
  if (!variantId) {
    showToast('Please select a color first.');
    return;
  }
  if (btnEl) {
    if (!btnEl.getAttribute('data-original-text')) btnEl.setAttribute('data-original-text', btnEl.textContent);
    btnEl.disabled = true;
    btnEl.textContent = 'Adding…';
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(res) {
    if (!res.ok) throw new Error('Cart error ' + res.status);
    return res.json();
  })
  .then(function() {
    if (redirectAfter) {
      window.location.href = '/checkout';
    } else {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cartData) {
          var badge = document.getElementById('cart-badge');
          if (badge) {
            badge.textContent = cartData.item_count;
            badge.classList.toggle('visible', cartData.item_count > 0);
          }
        });
      showToast('🛒  Added to cart!');
      if (btnEl) {
        btnEl.disabled = false;
        btnEl.textContent = btnEl.getAttribute('data-original-text') || 'Add to Cart';
      }
    }
  })
  .catch(function(err) {
    console.error('ssAddToCart error:', err);
    showToast('Something went wrong. Please try again.');
    if (btnEl) {
      btnEl.disabled = false;
      btnEl.textContent = btnEl.getAttribute('data-original-text') || 'Add to Cart';
    }
  });
}
function ssBuyNow(variantId) {
  ssAddToCart(variantId, null, true);
}

// ── CART (legacy in-memory, kept for SPA cart panel) ──
function addToCart(name, color, price, emoji) {
  const existing = cart.find(i => i.name === name && i.color === color);
  if (existing) {
    existing.qty++;
  } else {
    cart.push({ name, color, price, emoji, qty: 1 });
  }
  updateCartBadge();
  showToast('🛒  Added to cart!');
}

function updateCartBadge() {
  const total = cart.reduce((s, i) => s + i.qty, 0);
  const badge = document.getElementById('cart-badge');
  badge.textContent = total;
  badge.classList.toggle('visible', total > 0);
}

function renderCart() {
  const el = document.getElementById('cart-content');
  if (!cart.length) {
    el.innerHTML = `
      <div class="empty-state">
        <div class="big-emoji">🛒</div>
        <h2 style="font-style:italic;margin-bottom:12px;">Your cart is empty</h2>
        <p class="subhead" style="margin:0 auto 28px;">Looks like you haven't added anything yet.</p>
        <button class="btn btn-primary btn-lg" onclick="showPage('shop')">Shop Now →</button>
      </div>`;
    return;
  }
  const subtotal = cart.reduce((s,i) => {
    const num = parseFloat(i.price.replace('$','').replace(',',''));
    return s + num * i.qty;
  }, 0);

  el.innerHTML = `
    <div class="cart-layout">
      <div>
        ${cart.map((item,idx) => `
          <div class="cart-item">
            <div class="cart-item-img" style="font-size:2.5rem;">${item.emoji}</div>
            <div style="flex:1;">
              <div class="cart-item-title">${item.name}</div>
              <div style="font-size:0.72rem;color:var(--teal);font-weight:600;letter-spacing:0.08em;text-transform:uppercase;margin-bottom:3px;">Trampoline Ottoman™ furniture</div>
              <div class="cart-item-variant">${item.color}</div>
              <div class="qty-control">
                <button class="qty-btn" onclick="changeQty(${idx},-1)">−</button>
                <input class="qty-val" value="${item.qty}" onchange="setQty(${idx},this.value)">
                <button class="qty-btn" onclick="changeQty(${idx},1)">+</button>
              </div>
            </div>
            <div style="text-align:right;">
              <div class="cart-item-price">${item.price}</div>
              <button onclick="removeItem(${idx})" style="font-size:0.72rem;color:var(--text-muted);text-decoration:underline;margin-top:8px;cursor:pointer;background:none;border:none;">Remove</button>
            </div>
          </div>
        `).join('')}
      </div>
      <div class="cart-summary-box">
        <h3>Order Summary</h3>
        <div class="summary-row"><span>Subtotal</span><span>$${subtotal.toFixed(2)}</span></div>
        <div class="summary-row"><span>Shipping</span><span style="color:var(--teal);font-weight:600;">FREE</span></div>
        <div class="summary-row"><span>Estimated Tax</span><span>Calculated at checkout</span></div>
        <div class="summary-total"><span>Total</span><span>$${subtotal.toFixed(2)}</span></div>
        <p class="summary-note">Free shipping on all orders · 30-day guarantee</p>
        <button class="btn btn-primary btn-full btn-lg" style="margin-top:20px;" onclick="showToast('🎉 Checkout would open in Shopify!')">Checkout →</button>
        <div style="text-align:center;margin-top:12px;">
          <a onclick="showPage('shop')" style="font-size:0.78rem;color:var(--text-muted);text-decoration:underline;cursor:pointer;">← Continue Shopping</a>
        </div>
      </div>
    </div>`;
}

function changeQty(idx, delta) {
  cart[idx].qty = Math.max(0, cart[idx].qty + delta);
  if (cart[idx].qty === 0) cart.splice(idx, 1);
  updateCartBadge();
  renderCart();
}
function setQty(idx, val) {
  const q = parseInt(val);
  if (q <= 0) { cart.splice(idx, 1); } else { cart[idx].qty = q; }
  updateCartBadge();
  renderCart();
}
function removeItem(idx) {
  cart.splice(idx, 1);
  updateCartBadge();
  renderCart();
}

// ── FAQ ──
function renderFaq() {
  const container = document.getElementById('faq-list');
  const cats = [
    { key: 'product', label: 'Product Info' },
    { key: 'ordering', label: 'Placing Your Order' },
    { key: 'shipping', label: 'Shipping & Delivery' },
    { key: 'returns', label: 'Returns, Exchanges & Warranty' },
    { key: 'care', label: 'Care & Maintenance' }
  ];
  let out = '';
  cats.forEach(cat => {
    const items = faqs.filter(f => f.cat === cat.key);
    if (!items.length) return;
    out += `<div class="faq-category" data-cat="${cat.key}">`;
    out += `<h3 style="font-size:0.7rem;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:var(--teal);margin:40px 0 16px;">${cat.label}</h3>`;
    items.forEach((f, i) => {
      const id = cat.key + '_' + i;
      out += `<div class="faq-item" id="faq-${id}" data-cat="${cat.key}">`;
      out += `<div class="faq-question" onclick="toggleFaqById('${id}')">`;
      out += `<span>${f.q}</span><span class="faq-toggle">+</span></div>`;
      out += `<div class="faq-answer">${f.a}</div></div>`;
    });
    out += '</div>';
  });
  container.innerHTML = out;
}

function toggleFaqById(id) {
  const item = document.getElementById('faq-' + id);
  if (!item) return;
  item.classList.toggle('open');
  const toggle = item.querySelector('.faq-toggle');
  if (toggle) toggle.textContent = item.classList.contains('open') ? '\u2212' : '+';
}

function toggleFaq(idx) {
  const item = document.getElementById('faq-' + idx);
  if (item) item.classList.toggle('open');
}

function filterFaq(cat, btn) {
  document.querySelectorAll('.faq-tab').forEach(t => t.classList.remove('active'));
  if (btn) btn.classList.add('active');
  document.querySelectorAll('.faq-category').forEach(section => {
    section.style.display = (cat === 'all' || section.getAttribute('data-cat') === cat) ? '' : 'none';
  });
}

// ── NEWSLETTER ──
function subscribeNewsletter() {
  const input = document.querySelector('.newsletter-input');
  if (input && input.value && input.value.includes('@')) {
    showToast('🎉 Thanks for subscribing!');
    input.value = '';
  } else {
    showToast('Please enter a valid email address.');
  }
}

// ── TOAST ──
let toastTimer;
function showToast(msg) {
  const toast = document.getElementById('toast');
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('show'), 2500);
}

// ── SCROLL REVEAL ──
function initReveal() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
  document.querySelectorAll('.reveal:not(.visible)').forEach(el => observer.observe(el));
}

// Inline editing enhancement removed (production build — reduces global event listener overhead)

// ── INIT ──
// ── IMAGE INJECTION ──
function initImages() {
  // ── HOMEPAGE ──────────────────────────────────────────────
  const hCardImg = document.getElementById('hp-card-img');
  const bCardImg = document.getElementById('bp-card-img');
  if (hCardImg) hCardImg.src = ssAsset(IMGS.b_main);              // bounder product shot
  if (bCardImg) bCardImg.src = ssAsset(IMGS.b_main);               // bounder main

  // Cross-sell cards — src is now set via Liquid (product.media.first), do not overwrite here

  // Hero background - family aspiration
  const heroBg = document.getElementById('hero-bg-img');
  if (heroBg) {
    const bgImg = heroBg.querySelector('img');
    if (bgImg) bgImg.src = 'hero-final.jpg';
    heroBg.style.opacity = '1';
  }

  // ── SHOP PAGE ─────────────────────────────────────────────
  const shopH = document.getElementById('shop-h-img');
  const shopB = document.getElementById('shop-b-img');
  if (shopH) shopH.src = ssAsset(IMGS.b_main);                 // bounder living room
  if (shopB) shopB.src = ssAsset(IMGS.b_main);                    // bounder main

  // ── HOPPER PDP & BOUNDER PDP ─────────────────────────────
  // Gallery main image and thumbnails are now rendered via Liquid (product.media)
  // Do NOT overwrite them here — JS injection caused broken images from missing assets

  // ── CART ──────────────────────────────────────────────────
  // renderCart() uses IMGS.h_main / IMGS.b_main - override
  window.CART_IMG_HOPPER = IMGS.h_main;
  window.CART_IMG_BOUNDER = IMGS.b_main;

  // ── LIFESTYLE STRIP ─ now static HTML marquee, no JS needed
}

function addLifestyleStrip() {
  // Replaced by static HTML marquee — no-op
}

function selectPdpThumb(el, mainImgId) {
  const key = el.dataset.srcKey;
  const mainImg = document.getElementById(mainImgId);
  if (mainImg && key && IMGS[key]) mainImg.src = ssAsset(IMGS[key]);
  el.closest('.pdp-thumbs').querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
}

// Enhance cart rendering to use images
const _origRenderCart = renderCart;
renderCart = function() {
  _origRenderCart();
  // Patch cart item images
  document.querySelectorAll('.cart-item-img').forEach(el => {
    const titleEl = el.closest('.cart-item')?.querySelector('.cart-item-title');
    if (!titleEl) return;
    const title = titleEl.textContent;
    const key = 'b_main';
    if (IMGS[key]) {
      el.style.fontSize = '0';
      el.style.padding = '0';
      el.style.overflow = 'hidden';
      el.innerHTML = `<img src="${IMGS[key]}" style="width:100%;height:100%;object-fit:cover;">`;
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Defer image injection to idle time — doesn't affect INP or LCP
  if (window.requestIdleCallback) {
    requestIdleCallback(initImages, { timeout: 2000 });
  } else {
    setTimeout(initImages, 100);
  }
  initReveal();
});

  function showBlogPost(idx) {
    document.getElementById('blog-list-view').style.display = 'none';
    document.getElementById('blog-article-view').style.display = 'block';
    document.querySelectorAll('.blog-article').forEach(a => a.style.display = 'none');
    const art = document.getElementById('blog-' + idx);
    if (art) { art.style.display = 'block'; window.scrollTo(0,0); }
  }
  function showBlogList() {
    document.getElementById('blog-list-view').style.display = 'block';
    document.getElementById('blog-article-view').style.display = 'none';
    document.querySelectorAll('.blog-article').forEach(a => a.style.display = 'none');
    window.scrollTo(0,0);
  }


  // ── Bounder three-tier fabric selector ──
  // Cache Bounder tier DOM refs once at first use
  var _bTierCache = null;
  function _getBTierEls() {
    if (!_bTierCache) {
      _bTierCache = {
        solidBtn: document.getElementById('tier-solid-btn'),
        patternBtn: document.getElementById('tier-pattern-btn'),
        customBtn: document.getElementById('tier-custom-btn'),
        solidSwatches: document.getElementById('swatches-solid'),
        patternSwatches: document.getElementById('swatches-pattern'),
        customPanel: document.getElementById('bounder-custom-panel'),
        purchaseBtns: document.getElementById('bounder-purchase-btns'),
        swatchNameEl: document.querySelector('.swatch-name'),
        priceEl: document.getElementById('bounder-price'),
        priceNote: document.getElementById('bounder-price-note')
      };
    }
    return _bTierCache;
  }

  function selectBoundarTier(tier) {
    window._bounderTier = tier;
    var e = _getBTierEls();
    // Immediate: highlight selected tier button for instant visual feedback
    var activeColor = (tier === 'custom') ? 'var(--teal)' : 'var(--green)';
    [e.solidBtn, e.patternBtn, e.customBtn].forEach(function(btn) {
      if (btn) { btn.style.background = 'white'; btn.style.color = 'var(--text)'; btn.style.borderColor = 'var(--border)'; }
    });
    var activeBtn = tier === 'solid' ? e.solidBtn : tier === 'pattern' ? e.patternBtn : e.customBtn;
    if (activeBtn) { activeBtn.style.background = activeColor; activeBtn.style.color = 'white'; activeBtn.style.borderColor = activeColor; }

    // Defer heavier DOM updates to next animation frame
    requestAnimationFrame(function() {
      if (tier === 'solid') {
        e.solidSwatches.style.display = 'block';
        e.patternSwatches.style.display = 'none';
        if (e.customPanel) e.customPanel.style.display = 'none';
        if (e.purchaseBtns) e.purchaseBtns.style.display = 'block';
        if (e.swatchNameEl) e.swatchNameEl.style.display = 'block';
        if (e.priceNote) e.priceNote.textContent = 'Commercial-grade performance fabric — bleach-cleanable, PFAS-free, built for families.';
        var firstSolid = e.solidSwatches.querySelector('.swatch');
        if (firstSolid) selectBoundarSwatch(firstSolid, firstSolid.title || firstSolid.getAttribute('data-color') || '', 'solid');
      } else if (tier === 'pattern') {
        e.solidSwatches.style.display = 'none';
        e.patternSwatches.style.display = 'block';
        if (e.customPanel) e.customPanel.style.display = 'none';
        if (e.purchaseBtns) e.purchaseBtns.style.display = 'block';
        if (e.swatchNameEl) e.swatchNameEl.style.display = 'block';
        if (e.priceNote) e.priceNote.textContent = 'Curated designer upholstery — artisan weaves and patterns for the design-forward home.';
        var firstPattern = e.patternSwatches.querySelector('.swatch');
        if (firstPattern) selectBoundarSwatch(firstPattern, firstPattern.title || firstPattern.getAttribute('data-color') || '', 'pattern');
      } else {
        e.solidSwatches.style.display = 'none';
        e.patternSwatches.style.display = 'none';
        if (e.customPanel) e.customPanel.style.display = 'block';
        if (e.purchaseBtns) e.purchaseBtns.style.display = 'none';
        if (e.swatchNameEl) e.swatchNameEl.style.display = 'none';
        if (e.priceEl) e.priceEl.textContent = 'From $749';
        if (e.priceNote) e.priceNote.textContent = 'Custom fabric order — pricing depends on fabric sourcing. We\'ll confirm the final quote by email.';
      }
      if (typeof updateBounderPrice === 'function') updateBounderPrice();
    });
  }

  function selectBoundarSwatch(el, colorName, tier) {
    // Immediate: mark this swatch active for instant visual feedback
    el.classList.add('active');
    var name = colorName || el.title || el.getAttribute('data-color') || '';
    window._bounderTier = tier;
    var fabricLabel = tier === 'solid' ? 'Performance Solids' : 'Designer Patterns';
    var skirtLabel = (window._bounderSkirt === 'ruffled') ? 'Ruffled' : 'Pleated';
    // Track variant ID immediately (needed for ATC) — include skirt in lookup
    var idMap = window.SS_VARIANT_ID_MAP_BOUNDER;
    if (idMap) {
      window._bounderCurrentVariantId =
        idMap[fabricLabel + ' / ' + name + ' / ' + skirtLabel] ||
        idMap[name + ' / ' + skirtLabel] ||
        idMap[fabricLabel + ' / ' + name] ||
        idMap[name] ||
        null;
    }
    // Defer heavier DOM work to next animation frame
    requestAnimationFrame(function() {
      var parent = el.closest('.swatches');
      if (parent) {
        var swatches = parent.querySelectorAll('.swatch');
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i] !== el) swatches[i].classList.remove('active');
        }
      }
      var nameEl = document.getElementById('bounder-color-name');
      if (nameEl) nameEl.textContent = name;
      if (typeof updateBounderPrice === 'function') updateBounderPrice();
      if (typeof bounderUpdateVariantImage === 'function') bounderUpdateVariantImage(fabricLabel, name, skirtLabel);
    });
  }

  // ── Hopper two-tier fabric selector ──
  // Cache Hopper tier DOM refs once at first use
  var _hTierCache = null;
  function _getHTierEls() {
    if (!_hTierCache) {
      _hTierCache = {
        microBtn: document.getElementById('hopper-tier-micro-btn'),
        perfBtn: document.getElementById('hopper-tier-perf-btn'),
        microSwatches: document.getElementById('hopper-swatches-micro'),
        perfSwatches: document.getElementById('hopper-swatches-perf'),
        priceEl: document.getElementById('hopper-price'),
        priceNote: document.getElementById('hopper-price-note')
      };
    }
    return _hTierCache;
  }

  function selectHopperTier(tier) {
    var e = _getHTierEls();
    // Immediate: highlight selected tier button
    if (tier === 'micro') {
      e.microBtn.style.background = 'var(--orange)'; e.microBtn.style.color = 'white'; e.microBtn.style.borderColor = 'var(--orange)';
      e.perfBtn.style.background = 'white'; e.perfBtn.style.color = 'var(--text)'; e.perfBtn.style.borderColor = 'var(--border)';
    } else {
      e.perfBtn.style.background = 'var(--orange)'; e.perfBtn.style.color = 'white'; e.perfBtn.style.borderColor = 'var(--orange)';
      e.microBtn.style.background = 'white'; e.microBtn.style.color = 'var(--text)'; e.microBtn.style.borderColor = 'var(--border)';
    }
    // Defer heavier DOM work to next animation frame
    requestAnimationFrame(function() {
      if (tier === 'micro') {
        e.microSwatches.style.display = 'block';
        e.perfSwatches.style.display = 'none';
        e.priceEl.textContent = '$399';
        e.priceNote.textContent = 'Soft sensory microsuede — the classic Hopper, loved by kids everywhere.';
        var firstMicro = e.microSwatches.querySelector('.swatch');
        if (firstMicro) selectHopperSwatch(firstMicro, firstMicro.title || firstMicro.getAttribute('data-color') || '', 'micro');
      } else {
        e.microSwatches.style.display = 'none';
        e.perfSwatches.style.display = 'block';
        e.priceEl.textContent = '$599';
        e.priceNote.textContent = 'Commercial-grade performance fabric — bleach-cleanable, PFAS-free, built for families.';
        var firstPerf = e.perfSwatches.querySelector('.swatch');
        if (firstPerf) selectHopperSwatch(firstPerf, firstPerf.title || firstPerf.getAttribute('data-color') || '', 'perf');
      }
    });
  }

  function selectHopperSwatch(el, colorName, tier) {
    // Immediate: mark active for instant visual feedback
    el.classList.add('active');
    var name = colorName || el.title || el.getAttribute('data-color') || '';
    var fabricLabel = tier === 'micro' ? 'Microsuede' : 'Performance Solids';
    // Track variant ID immediately (needed for ATC)
    var idMap = window.SS_VARIANT_ID_MAP_HOPPER;
    if (idMap) window._hopperCurrentVariantId = idMap[fabricLabel + ' / ' + name] || idMap[name] || null;
    // Defer heavier DOM work to next animation frame
    requestAnimationFrame(function() {
      var parent = el.closest('.swatches');
      if (parent) {
        var swatches = parent.querySelectorAll('.swatch');
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i] !== el) swatches[i].classList.remove('active');
        }
      }
      var nameEl = document.getElementById('hopper-color-name');
      if (nameEl) nameEl.textContent = name;
      var priceEl = document.getElementById('hopper-price');
      if (priceEl) priceEl.textContent = tier === 'micro' ? '$399' : '$599';
      if (typeof hopperUpdateVariantImage === 'function') hopperUpdateVariantImage(fabricLabel, name);
    });
  }



(function() {
  function showEmailPopup() {
    var overlay = document.getElementById('email-popup-overlay');
    if (!overlay) return;

    // If user just submitted the form (page reloaded after Shopify POST), show success screen
    var justSubmitted = sessionStorage.getItem('ss_popup_just_submitted');
    if (justSubmitted) {
      sessionStorage.removeItem('ss_popup_just_submitted');
      // Show popup in success state
      overlay.style.display = 'flex';
      var form = document.getElementById('popup-form');
      var subtext = document.getElementById('popup-subtext');
      var noThanks = document.getElementById('popup-no-thanks');
      var success = document.getElementById('popup-success');
      if (form) form.style.display = 'none';
      if (subtext) subtext.style.display = 'none';
      if (noThanks) noThanks.style.display = 'none';
      if (success) success.style.display = 'block';
      return;
    }

    // Don't show popup if already submitted this session or ever
    if (sessionStorage.getItem('ss_popup_done') || localStorage.getItem('ss_popup_submitted')) return;

    overlay.style.display = 'flex';
    setTimeout(function() {
      var input = document.getElementById('popup-email-input');
      if (input) input.focus();
    }, 500);
  }

  // Trigger after 2.5 seconds
  setTimeout(showEmailPopup, 2500);

  // Close on overlay click (outside popup)
  document.addEventListener('DOMContentLoaded', function() {
    var overlay = document.getElementById('email-popup-overlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeEmailPopup();
      });
    }
  });
})();

function closeEmailPopup() {
  var overlay = document.getElementById('email-popup-overlay');
  if (overlay) {
    overlay.style.animation = 'none';
    overlay.style.opacity = '0';
    overlay.style.transition = 'opacity 0.25s';
    setTimeout(function() { overlay.style.display = 'none'; }, 250);
  }
  // Mark as dismissed for this session so it doesn't re-open
  try { sessionStorage.setItem('ss_popup_done', '1'); } catch(err) {}
}

// submitEmailPopup — called directly by the button onclick
// Uses a div (not a form tag) so Shopify's storefront JS cannot intercept it
function submitEmailPopup() {
  var emailInput = document.getElementById('popup-email-input');
  var submitBtn  = document.getElementById('popup-submit-btn');

  if (!emailInput) return;

  var email = emailInput.value.trim();
  if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
    emailInput.style.borderColor = '#c0392b';
    emailInput.focus();
    return;
  }

  if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Saving…'; }

  // Build form-encoded body manually (no <form> tag involved)
  var body = [
    'form_type=contact',
    'utf8=%E2%9C%93',
    'contact%5Bemail%5D=' + encodeURIComponent(email),
    'contact%5Bbody%5D=' + encodeURIComponent('Newsletter signup via popup — STITCH10 discount offered'),
    'contact%5Btags%5D=' + encodeURIComponent('newsletter, popup-signup, STITCH10')
  ].join('&');

  fetch('/contact', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'text/html'
    },
    body: body
  })
  .then(function() {
    try { localStorage.setItem('ss_popup_submitted', '1'); } catch(err) {}
    showPopupSuccess();
  })
  .catch(function() {
    // Even on network error, show success — the email was likely captured
    try { localStorage.setItem('ss_popup_submitted', '1'); } catch(err) {}
    showPopupSuccess();
  });
}

function showPopupSuccess() {
  var form = document.getElementById('popup-form');
  var subtext = document.getElementById('popup-subtext');
  var noThanks = document.getElementById('popup-no-thanks');
  var success = document.getElementById('popup-success');
  if (form) form.style.display = 'none';
  if (subtext) subtext.style.display = 'none';
  if (noThanks) noThanks.style.display = 'none';
  if (success) success.style.display = 'block';
  try { localStorage.setItem('ss_popup_submitted', '1'); } catch(err) {}
}

// Close on Escape key
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeEmailPopup();
});

  
  // ═══════════════════════════════════════
  // HOPPER COVER PDP — Interactive Logic
  // ═══════════════════════════════════════

  // Track current Hopper Cover state
  var hcState = { tier: 'micro', color: 'Mint' };

  function selectHopperCoverTier(tier) {
    hcState.tier = tier;

    var microBtn = document.getElementById('hc-tier-micro-btn');
    var perfBtn  = document.getElementById('hc-tier-perf-btn');
    var microSwatches = document.getElementById('hc-swatches-micro');
    var perfSwatches  = document.getElementById('hc-swatches-perf');
    var priceEl  = document.getElementById('hopper-cover-price');

    var activeStyle   = 'flex:1;padding:11px 10px;border-radius:10px;border:2px solid var(--teal);background:var(--teal);color:white;font-size:0.82rem;font-weight:600;cursor:pointer;transition:all 0.2s;';
    var inactiveStyle = 'flex:1;padding:11px 10px;border-radius:10px;border:2px solid var(--border);background:white;color:var(--text);font-size:0.82rem;font-weight:600;cursor:pointer;transition:all 0.2s;';

    if (tier === 'micro') {
      microBtn.style.cssText  = activeStyle;
      perfBtn.style.cssText   = inactiveStyle;
      microSwatches.style.display = '';
      perfSwatches.style.display  = 'none';
      priceEl.textContent = '$299';
      // Reset swatch selection to first micro swatch
      var firstMicroSwatch = microSwatches.querySelector('.swatch');
      if (firstMicroSwatch) selectHopperCoverSwatch(firstMicroSwatch, firstMicroSwatch.title || firstMicroSwatch.getAttribute('data-color') || '', 'micro');
    } else {
      perfBtn.style.cssText   = activeStyle;
      microBtn.style.cssText  = inactiveStyle;
      perfSwatches.style.display  = '';
      microSwatches.style.display = 'none';
      priceEl.textContent = '$399';
      // Reset swatch selection to first perf swatch
      var firstPerfSwatch = perfSwatches.querySelector('.swatch');
      if (firstPerfSwatch) selectHopperCoverSwatch(firstPerfSwatch, firstPerfSwatch.title || firstPerfSwatch.getAttribute('data-color') || '', 'perf');
    }
  }

  function selectHopperCoverSwatch(el, colorName, tier) {
    var name = colorName || (el && (el.title || el.getAttribute('data-color'))) || '';
    hcState.color = name;
    // Immediate: mark active
    if (el) el.classList.add('active');
    var fabricLabel = (tier === 'perf') ? 'Performance Solids' : 'Microsuede';
    // Track variant ID immediately
    var idMap = window.SS_VARIANT_ID_MAP_HOPPER_COVER;
    if (idMap) window._hopperCoverCurrentVariantId = idMap[fabricLabel + ' / ' + name] || idMap[name] || null;
    // Defer heavier DOM work to next animation frame
    requestAnimationFrame(function() {
      var panelId = (tier === 'micro') ? 'hc-swatches-micro' : 'hc-swatches-perf';
      var panel = document.getElementById(panelId);
      if (panel) {
        var swatches = panel.querySelectorAll('.swatch');
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i] !== el) swatches[i].classList.remove('active');
        }
      }
      var colorNameEl = document.getElementById('hc-color-name');
      if (colorNameEl) colorNameEl.textContent = name;
      if (typeof hopperCoverUpdateVariantImage === 'function') {
        hopperCoverUpdateVariantImage(fabricLabel, name);
      } else {
        var imgEl = document.getElementById('hopper-cover-img-el');
        if (imgEl) imgEl.src = (tier === 'perf') ? 'cover-hopper-perf.png' : 'cover-hopper.png';
      }
    });
  }

  // ═══════════════════════════════════════
  // BOUNDER COVER PDP — Interactive Logic
  // ═══════════════════════════════════════

  // Track current Bounder Cover state
  var bcState = { skirt: 'pleated', tier: 'perf', color: 'Oat' };

  function selectBounderCoverSkirt(skirt) {
    bcState.skirt = skirt;

    var pleatedBtn = document.getElementById('bc-skirt-pleated-btn');
    var ruffledBtn = document.getElementById('bc-skirt-ruffled-btn');

    var activeStyle   = 'flex:1;padding:10px;border-radius:10px;border:2px solid var(--teal);background:var(--teal);color:white;font-size:0.82rem;font-weight:600;cursor:pointer;transition:all 0.2s;';
    var inactiveStyle = 'flex:1;padding:10px;border-radius:10px;border:2px solid var(--border);background:white;color:var(--text);font-size:0.82rem;font-weight:600;cursor:pointer;transition:all 0.2s;';

    if (skirt === 'pleated') {
      pleatedBtn.style.cssText = activeStyle;
      ruffledBtn.style.cssText = inactiveStyle;
    } else {
      ruffledBtn.style.cssText = activeStyle;
      pleatedBtn.style.cssText = inactiveStyle;
    }

    // Update main image to reflect skirt + current tier/color
    var fabricLabel = (bcState.tier === 'print') ? 'Designer Patterns' : 'Performance Solids';
    if (typeof bounderCoverUpdateVariantImage === 'function') {
      bounderCoverUpdateVariantImage(fabricLabel, bcState.color, skirt === 'pleated' ? 'Pleated' : 'Ruffled');
    } else {
      var imgEl = document.getElementById('bounder-cover-img-el');
      if (imgEl) imgEl.src = skirt === 'ruffled' ? 'cover-bounder-ruffled.png' : (bcState.tier === 'print' ? 'cover-bounder-print.jpg' : 'cover-bounder.png');
    }
  }

  function selectBounderCoverTier(tier) {
    bcState.tier = tier;

    var perfBtn  = document.getElementById('bc-tier-perf-btn');
    var printBtn = document.getElementById('bc-tier-print-btn');
    var perfSwatches  = document.getElementById('bc-swatches-perf');
    var printSwatches = document.getElementById('bc-swatches-print');
    var priceEl  = document.getElementById('bounder-cover-price');

    var activeStyle   = 'flex:1;padding:11px 10px;border-radius:10px;border:2px solid var(--teal);background:var(--teal);color:white;font-size:0.82rem;font-weight:600;cursor:pointer;transition:all 0.2s;';
    var inactiveStyle = 'flex:1;padding:11px 10px;border-radius:10px;border:2px solid var(--border);background:white;color:var(--text);font-size:0.82rem;font-weight:600;cursor:pointer;transition:all 0.2s;';

    if (tier === 'perf') {
      perfBtn.style.cssText   = activeStyle;
      printBtn.style.cssText  = inactiveStyle;
      perfSwatches.style.display  = '';
      printSwatches.style.display = 'none';
      priceEl.textContent = '$429';
      var firstSwatch = perfSwatches.querySelector('.swatch');
      if (firstSwatch) selectBounderCoverSwatch(firstSwatch, firstSwatch.title || firstSwatch.getAttribute('data-color') || '', 'perf');
    } else {
      printBtn.style.cssText  = activeStyle;
      perfBtn.style.cssText   = inactiveStyle;
      printSwatches.style.display = '';
      perfSwatches.style.display  = 'none';
      priceEl.textContent = '$599';
      var firstSwatch = printSwatches.querySelector('.swatch');
      if (firstSwatch) selectBounderCoverSwatch(firstSwatch, firstSwatch.title || firstSwatch.getAttribute('data-color') || '', 'print');
    }
  }

  function selectBounderCoverSwatch(el, colorName, tier) {
    var name = colorName || (el && (el.title || el.getAttribute('data-color'))) || '';
    bcState.color = name;
    // Immediate: mark active
    if (el) el.classList.add('active');
    var fabricLabel = (tier === 'print') ? 'Designer Patterns' : 'Performance Solids';
    var skirtLabel = bcState.skirt === 'ruffled' ? 'Ruffled' : 'Pleated';
    // Track variant ID immediately
    var idMap = window.SS_VARIANT_ID_MAP_BOUNDER_COVER;
    if (idMap) window._bounderCoverCurrentVariantId = idMap[fabricLabel + ' / ' + name] || idMap[name] || null;
    // Defer heavier DOM work to next animation frame
    requestAnimationFrame(function() {
      var panelId = (tier === 'print') ? 'bc-swatches-print' : 'bc-swatches-perf';
      var panel = document.getElementById(panelId);
      if (panel) {
        var swatches = panel.querySelectorAll('.swatch');
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i] !== el) swatches[i].classList.remove('active');
        }
      }
      var colorNameEl = document.getElementById('bc-color-name');
      if (colorNameEl) colorNameEl.textContent = name;
      if (typeof bounderCoverUpdateVariantImage === 'function') {
        bounderCoverUpdateVariantImage(fabricLabel, name, skirtLabel);
      } else {
        var imgEl = document.getElementById('bounder-cover-img-el');
        if (imgEl) imgEl.src = (tier === 'print') ? 'cover-bounder-print.jpg' : 'cover-bounder.png';
      }
    });
  }

function toggleStory() {
  const body = document.getElementById('story-content');
  const navLink = document.getElementById('story-nav-link');
  const isOpen = body.style.opacity === '1';
  if (isOpen) {
    body.style.maxHeight = '0';
    body.style.opacity = '0';
    if (navLink) navLink.style.color = '';
  } else {
    body.style.maxHeight = body.scrollHeight + 'px';
    body.style.opacity = '1';
    if (navLink) navLink.style.color = 'var(--teal)';
    setTimeout(() => body.scrollIntoView({behavior:'smooth', block:'start'}), 80);
  }
}

function toggleSEO() {    const body = document.getElementById('seo-body');
    const chevron = document.getElementById('seo-chevron');
    const btn = document.getElementById('seo-toggle');
    const label = document.getElementById('seo-toggle-label');
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      body.style.maxHeight = '0';
      body.style.opacity = '0';
      chevron.style.transform = 'rotate(0deg)';
      btn.setAttribute('aria-expanded', 'false');
      label.textContent = 'About Spring & Stitch';
    } else {
      body.style.maxHeight = body.scrollHeight + 'px';
      body.style.opacity = '1';
      chevron.style.transform = 'rotate(180deg)';
      btn.setAttribute('aria-expanded', 'true');
      label.textContent = 'About Spring & Stitch';
    }
  }
